import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useProjectState } from "../../../context/stateContext";
import discountActions from "../../../redux/discounts/actions";
import DiscountManagementTable from "../../../components/User/DiscountManagementComponents/DiscountManagementTable";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";

const { getAllUsersFromMyMenu, getAlLDiscounts } = discountActions;

const DiscountManagement = () => {
  const dispatch = useDispatch();

  const { organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const { selectedOrganization } = useProjectState();

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );
  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    dispatch(getAllUsersFromMyMenu());
    dispatch(getAlLDiscounts());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  return (
    <>
      <PageHeader text="Отстъпки" />
      <DiscountManagementTable />
    </>
  );
};

export default DiscountManagement;
